import { csrfTokenService } from '../csrf/CsrfTokenService'
import { ResetPasswordConfirmationData } from './types'

export class ResetPasswordConfirmationRepositoryFetch {
  async reset({
    password,
    token,
    uid,
  }: ResetPasswordConfirmationData): Promise<void> {
    const response = await this.getResponse(uid, token, password)
    if (response.errors) {
      throw this.mapError(response.errors)
    }
  }

  mapError(errors: any) {
    return {
      password: errors.new_password2,
      nonFieldErrors: errors.non_field_errors,
    }
  }

  private async getResponse(uid: string, token: string, password: string) {
    const { csrfToken } = await csrfTokenService()
    return $fetch(`/_/fallback/_/users/set-new-password/${uid}/${token}/`, {
      method: 'POST',
      body: this.getFormData(password),
      headers: {
        'X-CSRFToken': csrfToken,
      },
    })
  }

  getFormData(password: string): FormData {
    const formData = new FormData()
    formData.append('new_password1', password)
    formData.append('new_password2', password)
    return formData
  }
}
